import { useState } from 'react';
import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import WhyUniversalTrainingFails from './components/WhyUniversalTrainingFails';
import WhatIsCorporateProgram from './components/WhatIsCorporateProgram';
import WhenCompanyNeedsProgram from './components/WhenCompanyNeedsProgram';
import HowProgramIsDeveloped from './components/HowProgramIsDeveloped';
import WhatCompetenciesDevelop from './components/WhatCompetenciesDevelop';
import TrainingFormatComparison from './components/TrainingFormatComparison';
import GoodProgramStructure from './components/GoodProgramStructure';
import DevelopmentMistakes from './components/DevelopmentMistakes';
import CompanyResults from './components/CompanyResults';
import WhyAlexeySivko from './components/WhyAlexeySivko';
import CaseStudy from './components/CaseStudy';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import SEOBlock from './components/SEOBlock';
import ReadNextSection from './components/ReadNextSection';
import LeadMagnetBlock from '@/components/leadmagnet/LeadMagnetBlock';
import Footer from '@/components/feature/Footer';

const navLinks = [
  { label: 'Проблемы тренингов', target: 'why-universal-fails' },
  { label: 'Этапы разработки', target: 'how-developed' },
  { label: 'Форматы', target: 'formats' },
  { label: 'FAQ', target: 'faq' },
];

export default function CorpProgramPage() {


  return (
    <>
      
      <SeoTitle title="Разработка программ обучения | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={navLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />
        <WhyUniversalTrainingFails />
        <WhatIsCorporateProgram />
        <WhenCompanyNeedsProgram />
        <div id="how-developed">
          <HowProgramIsDeveloped />
        </div>
        <WhatCompetenciesDevelop />
        <div id="formats">
          <TrainingFormatComparison />
        </div>
        <GoodProgramStructure />
        <DevelopmentMistakes />
        <CompanyResults />
        <WhyAlexeySivko />
        <CaseStudy />
        <CTASection />
        <FAQSection />
        <SEOBlock />
        <LeadMagnetBlock variant="compact" />
        <ReadNextSection />
        <Footer />
      </div>
    </>
  );
}